import React from 'react'
import { DialogContent, DialogRoot } from '@/components/ui/dialog'

interface IframeDialogProps {
  isOpen: boolean
  onClose: () => void
  url: string
}

const FullScreenIframeDialog = ({
  isOpen,
  onClose,
  url,
}: IframeDialogProps) => {
  return (
    <DialogRoot size={'full'} open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <iframe
          src={url}
          style={{
            width: '100%',
            height: '100vh',
          }}
          allow='payment'
        />
      </DialogContent>
    </DialogRoot>
  )
}

export default FullScreenIframeDialog
